import React from "react";
import i18nhelper from "../../../../app/components/helpers/i18n.helper";
import { useSelector } from "react-redux";
import history, { getQuery } from "../../../../app/interfaces/history";
import { Button } from "@/components/ui/button";
import { Folder } from "lucide-react";
import CustomFileIcon from "@/dumb-components/shared/file-icon/file-icon";

const FolderNameRenderer = ({ props }) => {
  const query = getQuery();
  const { isSharedFromCompanyId } = query;
  const isWithinSharedFolder = typeof isSharedFromCompanyId !== "undefined";
  const i18n = useSelector((state) => state.i18n);
  const company = useSelector((state) => state.company.company);
  const { id, folderId, metadata, basePath, title } = props.data;
  const { folderName } = metadata || {};

  const onBadgeClick = (documentId, folderId) => {
    history.push({
      pathname: basePath + `/${documentId}`,
      search: `?folder=${folderId}${
        isWithinSharedFolder
          ? `&isSharedFromCompanyId=${isSharedFromCompanyId}`
          : ""
      }`,
    });
  };

  const ext = props.data?.file?.ext;

  return (
    <div className="flex items-center gap-2">
      <div className="flex flex-1 items-center justify-start gap-3 truncate">
        <div className="max-w-[16px]">
          <CustomFileIcon ext={ext} />
        </div>
        <div className="truncate">{title}</div>
      </div>
      {folderId && (
        <div className="flex h-full items-center justify-end">
          <Button
            size="sm"
            variant="outline"
            className="rounded-full border-slate-300 bg-transparent transition-transform hover:scale-105 hover:border-slate-400 hover:bg-background"
            onClick={onBadgeClick.bind(this, id, folderId)}
          >
            <Folder className="text-slate-300" size={14} />{" "}
            {i18nhelper.getTranslatedValue(
              folderName,
              i18n.language,
              company.region,
            )}
          </Button>
        </div>
      )}
    </div>
  );
};

export default FolderNameRenderer;
